import React, {useContext, useEffect, useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {Typography, Button, Grid, DialogTitle, Dialog, DialogContent, TextField, Paper} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import SimpleAlert from "../../../components/Alert/SimpleAlert";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {AddCircle} from "@material-ui/icons";
import {MACROTHEMES_TYPES} from "../../../utils/constants";
import CircularProgress from "@material-ui/core/CircularProgress";
import {optionFaqAdminLabel} from "../add/formatters";
import TripletsList from "../TripletsList";
import {useHistory} from "react-router-dom";
import CountryContext from "../../../CountryContext";
import useCountryAxiosInstance from "../../../hooks/useCountryAxiosInstance";
import apiRequest from "../../../services/apiRequest";
import {PRIVILEGED_ROLES} from "../../../constants";

const useStyles = makeStyles(() => ({
  formField: {
    width: "100%",
    marginBottom: 15
  },
  button: {
    float: "right"
  },
  addIcon: {
    width: 30,
    height: 30,
    marginRight: 10
  },
}));

export default function FaqTriplets() {
  const classes = useStyles();
  const [triplets, setTriplets] = useState([]);
  const [adminsOptions, setAdminsOptions] = useState();
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const toggleOpenDialog = () => setOpenAddDialog(!openAddDialog);


  const [loading, setLoading] = useState(false);
  const [verticalSelected, setVerticalSelected] = useState();
  const [macrotemaSelected, setMacrotemaSelected] = useState();
  const [addMacrotema, setAddMacrotema] = useState(false);
  const [newMacrotema, setNewMacrotema] = useState();
  const [adminSelected, setAdminSelected] = useState();
  const [macrotemaVisibility, setMacrotemaVisibility] = useState(MACROTHEMES_TYPES[2]);
  const [newTema, setNewTema] = useState();

  const apiRequestCountry = useCountryAxiosInstance();
  const history = useHistory();
  const {country} = useContext(CountryContext);


  const [alert, setAlert] = useState({open: false, type: "", message: ""});
  const openAlert = (type, message) => {
    setAlert({open: true, type, message})
  }
  const toggleAlert = () => {
    setAlert({...alert, open: !alert.open})
  }

  const navigateTo = (target) => {
    history.push(`/${country.code}/kerakoll_assistant${target}`);
  };


  const getAdminsForReference = () => {
    //TODO: cambiare con anche CS e field, non solo admin
    //prendere i nuovi admin dal nuovo backend usando apiRequestCountry di shared può essere admin,CS,field
    //TODO: cambiare id referenti vecchi con quelli nuovi e aggiungrli se mancano, sia in dev che prod


    apiRequest.post("users/with_role", {role: [...PRIVILEGED_ROLES, "field"]})
      .then((res) => {
        setAdminsOptions(res);
      })
      .catch((err) => {
        console.log("err", err);
      });
    // ApiService.getEntries('users/admin')
    //   .then((response) => {
    //     console.log('getReferenceAdmins response', response)
    //     setAdminsOptions(response)
    //   })
  }

  function getVmtWithCount(faqs) {

    faqs.vmt.forEach(function (item) {
      item.question_ids = faqs['hits'].filter(function (el) {
        return el._source.vertical === item.vertical &&
          el._source.macrotema === item.macrotema &&
          el._source.tema === item.tema;
      }).map(i => i._id);
      item.question_count = item.question_ids.length;
    });

    faqs.vmt = faqs.vmt.filter(function (obj) {
      if (obj.vertical !== null && obj.macrotema !== null && obj.tema !== null) {
        return obj
      } else return false
    })

    faqs.vmt.sort((a, b) => a.vertical.localeCompare(b.vertical) ||
      a.macrotema.localeCompare(b.macrotema) ||
      a.tema.localeCompare(b.tema));

    return faqs.vmt
  }


  const fetchTriplets = () => {
    console.log('Fetching faqs....');
    apiRequestCountry.get('/assistant/get_all').then((result) => {
      setTriplets(getVmtWithCount(result))
    }).catch((err) => {
      console.error("Error when fetching faqs", err)
    })
  }


  useEffect(() => {
    if (!triplets || triplets.length === 0) {
      fetchTriplets()
    }
  }, [triplets]) // eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    if (!adminsOptions) {
      getAdminsForReference()
    }
  }, [adminsOptions]);

  function onVerticalChange(event, vertical) {
    setVerticalSelected(vertical)
    setMacrotemaSelected(undefined)
  }

  const _onAdd = () => {
    setLoading(true);
    const data = {
      vertical: verticalSelected,
      macrotema: newMacrotema ? String(newMacrotema).trim() : macrotemaSelected,
      tema: String(newTema).trim(),
      riservato_kerakoll: newMacrotema ? macrotemaVisibility.level
        : triplets.find(element => element['macrotema'] === macrotemaSelected)['riservato_kerakoll'],
      id_referente: newMacrotema ? adminSelected['id']
        : triplets.find(element => element['macrotema'] === macrotemaSelected)['id_referente']
    }

    apiRequestCountry.post('/assistant/themes', data)
      .then((result) => {    //
        toggleOpenDialog()
        setTriplets([])
        console.log('nuovo tema aggiunto correttamente')
        openAlert("success", "Nuovo tema aggiunto correttamente");
      })
      .catch((err) => {
        console.log(err)
        openAlert("error", "Errore imprevisto durante l'aggiunta del tema");
      })
      .finally(() => {
        setLoading(false)
      })

  }

  return (
    <>
      <Grid container>
        <Grid item xs={9}>
          <Typography variant="h6">Gestione Temi Kerakoll Assistant</Typography>
        </Grid>
        <Grid item xs={3}>
          <Button
            className={classes.button}
            onClick={() => {
              navigateTo("/")
            }}
            startIcon={<ArrowBackIcon color="primary"/>}>
            Indietro
          </Button>
        </Grid>
      </Grid>
      <hr/>
      <TripletsList
        triplets={triplets}
        adminsOptions={adminsOptions}
        openAlert={openAlert}
        setTriplets={setTriplets}
        toggleOpenDialog={toggleOpenDialog}
      />
      <SimpleAlert alert={alert} toggleAlert={toggleAlert}/>
      {triplets &&
      <Dialog
        open={openAddDialog}
        onClose={toggleOpenDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Aggiunta nuovo tema</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Autocomplete
                autoSelect
                autoComplete
                options={[...new Set(triplets.map(item => item.vertical).filter(i => i !== ''))]}
                onChange={onVerticalChange}
                value={verticalSelected || null}
                className={classes.formField}
                renderInput={(params) => (
                  <TextField {...params} label="Seleziona vertical" variant="outlined"/>
                )}
              />
            </Grid>
            <Grid item xs={11}>
              <Autocomplete
                autoSelect
                autoComplete
                options={[...new Set(triplets.filter(obj => obj.vertical === verticalSelected).map(item => item.macrotema))]}
                onChange={(e, v) => setMacrotemaSelected(v)}
                value={macrotemaSelected || null}
                className={classes.formField}
                renderInput={(params) => (
                  <TextField {...params} label="Seleziona macrotema" variant="outlined"/>
                )}
                disabled={!verticalSelected}
              />
            </Grid>
            <Grid item xs={1}>
              <Button
                color="primary"
                style={{marginTop: 10}}
                onClick={() => setAddMacrotema(true)}
                startIcon={<AddCircle className={classes.addIcon}/>}
                disabled={!verticalSelected}
              />
            </Grid>
            {addMacrotema &&
            <Grid item xs={12}>
              <Paper style={{padding: 20, marginBottom: 20}}>
                <Typography variant="subtitle1" style={{marginBottom: 10}}>
                  Aggiungi un nuovo macrotema per il vertical <b>{verticalSelected}</b>
                </Typography>
                <TextField
                  label="Nuovo macrotema"
                  variant="outlined"
                  className={classes.formField}
                  onChange={(e) => setNewMacrotema(e.target.value)}
                />
                <Autocomplete
                  options={adminsOptions}
                  onChange={(e, v) => setAdminSelected(v)}
                  getOptionLabel={optionFaqAdminLabel}
                  renderOption={optionFaqAdminLabel}
                  value={adminSelected || null}
                  className={classes.formField}
                  renderInput={(params) => (
                    <TextField {...params} label="Seleziona referente" variant="outlined"/>
                  )}
                  disabled={!verticalSelected}
                />
                <Autocomplete
                  id="level-visibility"
                  options={MACROTHEMES_TYPES}
                  getOptionLabel={(i) => `${i['label']}`}
                  renderOption={(i) => `${i['label']}`}
                  onChange={(e, v) => {
                    setMacrotemaVisibility(v)
                  }}
                  value={macrotemaVisibility}
                  className={classes.formField}
                  renderInput={(params) => (
                    <TextField {...params} label="Indica il livello di visibilità" variant="outlined"/>
                  )}
                  disabled={!verticalSelected}
                />

                <div style={{marginTop: 10, height: 30, textAlign: "center"}}>
                  <Button
                    onClick={() => setAddMacrotema(false)}
                    variant="contained"
                    style={{float: "left", fontSize: 10}}>
                    Chiudi
                  </Button>
                  {loading && <CircularProgress style={{marginLeft: "auto", marginRight: "auto"}}/>}
                  <Button
                    color="primary"
                    variant="contained"
                    style={{float: "right", marginBottom: 10, fontSize: 10}}
                    onClick={() => {
                      setMacrotemaSelected(newMacrotema)
                      setAddMacrotema(false)
                    }}
                    disabled={!newMacrotema || !adminSelected}
                  >
                    Aggiungi
                  </Button>
                </div>
              </Paper>
            </Grid>
            }
            {macrotemaSelected &&
            <Grid item xs={12}>
              <Typography variant="subtitle1" style={{marginBottom: 10}}>
                Aggiungi un nuovo tema per il macrotema <b>{macrotemaSelected}</b>
              </Typography>
              <TextField
                label="Nuovo tema"
                variant="outlined"
                className={classes.formField}
                onChange={(e) => setNewTema(e.target.value)}
              />
            </Grid>
            }
          </Grid>
        </DialogContent>
        <DialogContent>
          <div style={{textAlign: "center", marginTop: 10}}>
            <Button onClick={toggleOpenDialog} variant="contained" style={{float: "left", marginBottom: 10}}>
              Chiudi
            </Button>
            {loading && <CircularProgress style={{marginLeft: "auto", marginRight: "auto"}}/>}
            <Button
              onClick={_onAdd}
              disabled={!macrotemaSelected || !newTema}
              color="primary" variant="contained" style={{float: "right", marginBottom: 10}}
            >
              Invia
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      }
    </>
  );

}
